import React from "react";
import type { SVGProps } from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsDownload = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
        <path d="M21.8,13.5v8.3H2.2v-8.6H.7v10.2h22.5v-9.8h-1.5Z" />
        <path d="M11.8,17.9c.1.1.3.2.5.2s0,0,.1,0c.2,0,.3-.1.4-.2l6.5-5.6v-1.7l-6.3,5.5V.7h-1.4v15.4l-6.5-5.6v1.7l6.7,5.8h0Z" />
      </g>
    </SvgIcon>
  );
});

export default AppIconsDownload;
